import React from 'react';
import { Navigate } from 'react-router-dom';
import { ReviseIebPage } from '../components/marketing/revise/IebPage';
import { IEB_PAGE } from '../components/marketing/revise/content';
import { useMarketingTheme } from '../context/TenantContext';
import { useDocumentMeta } from '../lib/useDocumentMeta';

/**
 * `/ieb` — the IEB range, on its own page.
 *
 * The route exists for every published tenant because App.tsx registers it
 * beside `/free`, but the page is bespoke to one: every word of it is about
 * the IEB History exam, and `revise` is already allowlisted to a single
 * tenant. Any other theme is sent to the catalogue — the same guard, for the
 * same reason, as `/free`.
 *
 * `replace` so the redirect doesn't sit in history: someone who lands here by
 * accident and presses back should leave, not bounce.
 */
export const IebPage: React.FC = () => {
  const theme = useMarketingTheme();

  useDocumentMeta(theme === 'revise' ? IEB_PAGE.meta : {});

  if (theme !== 'revise') return <Navigate to="/courses" replace />;
  return <ReviseIebPage />;
};
